/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * 0 = Initial

1 = Pending

2 = Partially Complete

3 = Complete


 */
export type SignatureRequestStatus =
  (typeof SignatureRequestStatus)[keyof typeof SignatureRequestStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SignatureRequestStatus = {
  Initial: 0,
  Pending: 1,
  PartiallyComplete: 2,
  Complete: 3,
} as const;
